var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/radio-button/radio-button.tsx";
import React, { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';

/**
 * A group for radio input with label.
 */
const RadioButton = _ref => {
  let {
    name,
    value,
    checked,
    onChange,
    label
  } = _ref;
  const formFieldId = useMemo(() => "radio-".concat(uuidv4()), []);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: name,
    id: formFieldId,
    value: value,
    checked: checked,
    onChange: onChange,
    className: "h-4 w-4 border-gray-300 text-primary-600 focus:ring-primary-500",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: formFieldId,
    className: "ml-3 block text-sm font-medium text-gray-700",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 7
    }
  }, label));
};

export default RadioButton;